import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyC6Orl67DRUXPEM7-V8iaBEWU_2rragXLk",
  authDomain: "myproject-94a7a.firebaseapp.com",
  projectId: "myproject-94a7a",
  storageBucket: "myproject-94a7a.firebasestorage.app",
  messagingSenderId: "476382358328",
  appId: "1:476382358328:web:a57fb5de067deefff0afcd"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
